(function($) {
  
    $(document).ready(function() {
    });
  
})(jQuery);

function initLoader(){
    var $ = jQuery;

    var domainName = window.location.hostname;
    //console.log('init')
    $('.m-loader').addClass('is-loader-exiting');
    window.setTimeout(function(){
        $('.m-loader').removeClass('is-loader-exiting');
        $('.m-loader .loadpercent').width('0');
    },300)
    $('a').each(function(){
        if ($(this).hasClass('is-js-link') || $(this).parents('.language-switcher').length) {
            return;
        }
        var linkDirection = $(this).attr('href');
        //console.log(linkDirection.substring(0,1));
        if(linkDirection){
            if( linkDirection.indexOf(domainName) > -1 || linkDirection.substring(0,1) == '/' ){
                $(this).addClass('is-internal-link')
            }else{
                //$(this).attr('target','_blank');
            }
        }
    })

    $('.gtm-simple-event.is-internal-link').on('click',function(){
        var pix_categ = $(this).attr('gtm-categ');
        var pix_action = $(this).attr('gtm-action');
        var pix_label = $(this).attr('gtm-label');
        var pix_value = $(this).attr('gtm-value');
        /*window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 
            'pix_categ': pix_categ,
            'pix_action': pix_action,
            'pix_label': pix_label,
            'pix_value': pix_value,
        });*/
        ga('send', 'event', pix_categ, pix_action, pix_label, pix_value);
    })

    var smoothState = $("#js-sitecontainer")
      .smoothState({
        anchors: ".is-internal-link",
        forms: null,
        hrefRegex: /^(?!.*(wp-content)).*$/,
        alterRequest: function (request) {
          $(".m-loader .loadbar").width(0);
          //console.log('alterrequest')
          request.xhr = function () {
            var xhr = new window.XMLHttpRequest();
            //Download progress
            var loadedPercent = 0;
            xhr.addEventListener(
              "progress",
              function (e) {
                /*console.log('e');
                    console.log(e);
                    if (e.lengthComputable) {
                        var percentComplete = e.loaded / e.total*100;
                        console.log('compute '+percentComplete)
                        $('.loader .loadbar').width(percentComplete + "%");
                    } else {
                        loadedPercent += 5;
                        console.log('nocompute '+loadedPercent)
                        $('.loader .loadbar').width(Math.min(loadedPercent, 100) + "%");
                    }*/
              },
              false
            );
            xhr.addEventListener("load", function (e) {
              var regex = /<html.*?lang="([a-zA-Z\-]+)"/g;
              $("html").attr("lang", regex.exec(this.response)[1]);
            });
            return xhr;
          };

          return request;
        },
        onStart: {
          duration: 250, // Duration of our animation
          render: function ($container) {
            //console.log('start')
            pix_exit_page();
            $("#content").addClass("is-in-transition");
            $("body").addClass("is-in-transition");
            $("body").animate(function () {
              scrollTop: 0;
            }, 200);
            /*window.setTimeout(function(){
                    $('.cycle-slideshow').cycle('destroy');
                },300)*/
            // Add your CSS animation reversing class
            $(".m-loader").addClass("is-loader-active");
            // Restart your animation
            smoothState.restartCSSAnimations();
          },
        },
        onProgress: {
          duration: 200,
          render: function () {},
        },
        onAfter: function () {
          //console.log('after')
          $("#content").addClass("is-loaded");
          $(".m-loader").addClass("is-loader-exiting");
          $(".Loader .loader-logo").width(0);
        },
        onReady: {
          duration: 250,
          render: function ($container, $newContent) {
            //console.log('ready')
            //$('.m-loader').removeClass('is-loader-active');
            //$('.m-loader').removeClass('is-loader-exiting');
            $(window).scrollTop(0);
            $("#content").removeClass("is-loaded");
            // Inject the new content
            $container.html($newContent);
            $("body").removeClass("menu-expend");

            $("body").waitForImages({
              finished: function () {
                // Remove your CSS animation reversing class
                setTimeout(function () {
                  $(".m-loader").removeClass("is-loader-active");
                  $(".m-loader").addClass("is-loader-exiting");
                  $("#content").removeClass("is-in-transition");

                  window.a2a && window.a2a.init_all("page");
                  //ready();
                  $(".m-loader .loadbar").width(0);
                  pix_ready();
                  //initSmoothState();
                  /*$('.fancybox').fancybox({
                                live: false
                            });*/
                  $("body").removeClass("is-in-transition");
                  $(".cycle-slideshow").cycle();
                  //console.log('x');
                  $("body").removeClass("has-open-menu");
                  $("body").removeClass("mobile-menu-loggedin");
                }, 250);
              },
              each: function (loaded, count, failed) {
                var percent = ((loaded + 1) / count) * 100;
                $(".m-loader .loadbar").width(percent + "%");
              },
              //                    waitForAll: true
            });
          },
        },
      })
      .data("smoothState");
    //console.log(smoothState);
}